<template>
  <Layout class="g-wrapper g-vertical-block">
    <Content class="g-main-wrapper g-vertical-block">
      <Row :gutter="12">
        <Col span="24">
          <Tabs :value="currentRoute" @on-click="changeRouter">
            <TabPane name="personalcontrollist" label="人员消耗管控"></TabPane>
            <TabPane name="personalcontroladd" :label="addLabel" v-if="currentRoute === 'personalcontroladd'"></TabPane>
            <TabPane name="personalcontroldetail" label="消耗管控详情" v-if="currentRoute === 'personalcontroldetail'"></TabPane>
          </Tabs>
        </Col>
      </Row>
      <div class="c-content">
        <router-view />
      </div>
    </Content>
  </Layout>
</template>
<script>
export default {
  name: 'PersonalControlDefault',
  data() {
    return {
      currentRoute: '',
      access: this.$store.state.accessAuth
    }
  },
  methods: {
    changeRouter(name) {
      this.$router.replace({ name })
    },
    getCurrent() {
      this.currentRoute = this.$route.name
      if (this.$route.name === 'personalcontrol') this.changeRouter('personalcontrollist')
    }
  },
  watch: {
    $route: {
      handler() {
        this.getCurrent()
      },
      deep: true
    }
  },
  computed: {
    addLabel() {
      return this.$route.query.t === 'edit' ? '编辑人员消耗管控任务' : '创建人员消耗管控任务'
    }
  },
  created() {
    this.getCurrent()
  }
}
</script>
